import styled from "styled-components";
import { Typography, Card } from "antd";

const { Title, Paragraph } = Typography;

export const HeroSection = styled.section`
  background: linear-gradient(135deg, #c8eaa9 0%, #bbc9af 100%);
  color: white;
  padding: 80px 0;
  text-align: center;
`;

export const HeroContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
`;

export const HeroTitle = styled(Title)`
  font-size: 3rem;
  font-weight: bold;
  margin-bottom: 1rem;
  color: rgb(38 127 92) !important;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const HeroSubtitle = styled(Paragraph)`
  font-size: 1.2rem;
  margin-bottom: 2rem;
  opacity: 0.9;
  color: rgb(38 127 92) !important;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

export const ContactSection = styled.section`
  padding: 60px 0;
  background: #f5f5f5;
`;

export const ContactContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
`;

export const ContactCard = styled(Card)`
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 24px;
  margin-bottom: 24px;
`;

export const GallerySection = styled.section`
  padding: 60px 0;
  background: white;
`;

export const GalleryContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
`;

export const GalleryTitle = styled(Title)`
  text-align: center;
  margin-bottom: 40px;
  color: rgb(38 127 92) !important;
`;

export const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
  margin-bottom: 40px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

export const GalleryItem = styled.div`
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  }
`;

export const GalleryImage = styled.img`
  width: 100%;
  height: 250px;
  object-fit: cover;
  display: block;
`;

export const GalleryOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
  color: white;
  padding: 20px;
  transform: translateY(100%);
  transition: transform 0.3s ease;

  ${GalleryItem}:hover & {
    transform: translateY(0);
  }
`;

export const GalleryImageTitle = styled.h3`
  margin: 0 0 8px 0;
  font-size: 1.2rem;
  font-weight: 600;
`;

export const GalleryImageDescription = styled.p`
  margin: 0;
  font-size: 0.9rem;
  opacity: 0.9;
`;

export const SocialSection = styled.section`
  padding: 60px 0;
  background: #f5f5f5;
`;

export const SocialContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  text-align: center;
`;

export const SocialLinks = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-top: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const SocialLink = styled.a`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 4px;
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
  }

  &.facebook {
    background: #1877f2;
    color: white;
  }

  &.instagram {
    background: linear-gradient(
      45deg,
      #f09433 0%,
      #e6683c 25%,
      #dc2743 50%,
      #cc2366 75%,
      #bc1888 100%
    );
    color: white;
  }
`;

export const MapSection = styled.section`
  padding: 60px 0;
  background: white;
`;

export const MapContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
`;

export const MapTitle = styled(Title)`
  text-align: center;
  margin-bottom: 32px;
`;

export const MapWrapper = styled.div`
  height: 400px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const MapAddress = styled.div`
  text-align: center;
  margin-top: 16px;
`;

export const WorkingHoursRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`;
